import { gql } from "apollo-boost";

const SAVE = gql`
  mutation Save($item_id: ID!, $item_type: String!, $toggle_save: Boolean) {
    save(item_id: $item_id, item_type: $item_type, toggle_save: $toggle_save) {
      result
      analytics_data {
        user_id
        user_type
        flow
      }
    }
  }
`;

export default SAVE;
